import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isMaintenanceRoleName } from '../../utils/investorRole';

/**
 * Enlace único para notificaciones push: redirige al detalle según rol (admin vs mantenimiento).
 */
export const MaintenanceReportPushRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { user } = useAuth();

  if (!id) {
    return <Navigate to="/" replace />;
  }

  return isMaintenanceRoleName(user?.role?.name) ? (
    <Navigate to={`/maintenance/report/${id}`} replace />
  ) : (
    <Navigate to={`/property-management/report/${id}`} replace />
  );
};
